export enum ActiveLayer {
  MAP = 'MAP',
  SATELLITE = 'SATELLITE',
}
